<template>
  <div class="home">
    <van-nav-bar title="确认订单" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div class="address" v-on:click="selAddress">
      <div class="name">{{address.true_name}}{{address.tel}}</div>
      <p>{{address.area}}{{address.address}}</p>
    </div>
    <div v-for="item in list" :key="item.id" class="group">
      <div class="merchant">{{item.merchant_name}} {{item.num_sum}}件 {{item.price_sum}}元</div>
      <div class="g-list" v-for="g in item.goods" :key="g.id">
        <div class="m">
          <van-image width="100" height="100" fit="contain" :src="GLOBAL.IMG + g.thumbnail" />
        </div>
        <div class="r">
          <div class="t">{{g.post_title}}</div>
          <div class="arrt">{{g.attr}}</div>
          <div class="p">{{g.tprice}} × {{g.num}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="goods">
      <div class="merchant">{{item.merchant.merchant_name}}</div>
      <div class="g">
        <div class="left">
          <van-image height="70" fit="contain" :src="GLOBAL.IMG + item.thumbnail" />
        </div>
        <div class="right">
          <div class="t">{{item.post_title}}</div>
          <div class="price">{{item.price}}</div>
        </div>
      </div>
    </div>-->
    <div class="quan">
      <van-cell-group>
        <van-cell title="发票信息" value="电子发票 商品明细" />
        <van-cell title="优惠券" value="无可用" />
        <van-cell title="礼品卡" value="无可用" />
      </van-cell-group>
    </div>
    <div class="total">
      <table class="t_total">
        <tr>
          <td class="l">商品总额：</td>
          <td class="r">¥{{this.pay.goodsMoney}}</td>
        </tr>
        <tr>
          <td class="l">运费:</td>
          <td class="r">+ ¥{{this.pay.postMoney}}</td>
        </tr>
        <tr>
          <td class="l"></td>
          <td class="r">实付金额:¥{{this.pay.total}}</td>
        </tr>
      </table>
      <van-button round type="info" size="large" v-on:click="clickPay()">微信在线支付</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Cell, CellGroup } from "vant";

Vue.use(Cell);
Vue.use(CellGroup);
export default {
  name: "addressAdd",
  data() {
    return {
      user: { token: "", user: {} },
      address: {
        id: 0,
        true_name: "选择地址",
        address: "点击选择或者新增一个收货地址"
      },
      id: this.$route.params.id,
      item: { merchant: {} },
      list: [],
      pay: { total: 0, postMoney: 0, goodsMoney: 0 }
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getAddress() {
      let id = 0;
      let address = localStorage.getItem("address");
      if (address) {
        id = address;
      }

      this.$http
        .get(this.GLOBAL.API + "s_shop/address/getAddress/?id=" + id, {
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.address = data.data;
          }
        });
    },
    getGoods() {
      this.$http
        .get(this.GLOBAL.API + "s_tuan/goods/detail", {
          params: { id: this.id },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.item = data.data;
            let buyDetail = JSON.parse(localStorage.getItem("buyDetail"));
            data.data.num = buyDetail.num;
            data.data.attr_json = buyDetail.attr_json;
            data.data.attr =
              buyDetail.attr_json.n1 +
              "-" +
              buyDetail.attr_json.n2 +
              "-" +
              buyDetail.attr_json.n3;
            let l = {
              goods: [data.data],
              merchant_name: data.data.merchant.merchant_name,
              price_sum: data.data.tprice,
              num_sum: data.data.num,
            };
            this.list.push(l);

            this.pay.goodsMoney = (l.price_sum * l.num_sum).toFixed(2);
            this.pay.postMoney = 0;
            this.pay.total = (
              this.pay.postMoney + Number(this.pay.goodsMoney)
            ).toFixed(2);
            console.log(this.list);
          }
        });
    },

    buyNow() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_tuan/order/launch",
          {
            address_id: this.address.id,
            goods_id: this.list[0].goods[0].id,
            num: this.list[0].num_sum,
            attr_json: JSON.stringify(this.list[0].goods[0].attr_json),
            use_balance: 0
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.wxPay(data.data);
          } else {
            this.$toast(data.msg);
          }
        });
    },

    clickPay() {
      if (this.address.id == 0) {
        this.$toast("请选择收货地址");
        return;
      }
      this.buyNow();
    },
    wxPay(id) {
      window.location.replace(this.GLOBAL.URL + "/pay/index/index/id/" + id);
    },
    selAddress() {
      this.$router.push("/user/addresslist");
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.getAddress();
      this.getGoods();
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  background-color: #f6f6f6;
  text-align: left;
  .address {
    color: #666;
    padding: 16px 10px;
    background: #fff url("../../assets/orderAddrBg.png") -7px bottom repeat-x;
    background-size: 64px 5px;
    .name {
      font-size: 16px;
      font-weight: 700;
      color: #000;
    }
  }
  .goods {
    margin-top: 15px;
    background-color: #fff;
    .merchant {
      padding: 10px;
      font-size: 16px;
      font-weight: 700;
      border-bottom: 1px solid #ebedf0;
    }
    .g {
      padding: 10px;
      display: flex;
      line-height: 25px;
      .left {
        width: 20%;
      }
      .right {
        padding-left: 20px;
        width: 80%;
        .t {
          height: 50px;
          overflow: hidden;
        }
        .price {
          color: red;
        }
      }
    }
  }
  .total {
    background-color: #fff;
    margin-top: 15px;
    padding: 10px;
    table {
      width: 100%;
      margin-bottom: 10px;
      tr {
        .l {
          width: 50%;
        }
        .r {
          width: 50%;
          text-align: right;
          color: red;
        }
      }
    }
  }
  .quan {
    background-color: #fff;
    margin-top: 15px;
  }
}
.group {
  background-color: #fff;
  text-align: left;
  padding: 10px;
  .merchant {
    font-size: 18px;
    font-weight: 500;
  }
  .g-list {
    display: flex;
    margin-top: 10px;
    border-bottom: 1px solid #ebedf0;
    line-height: 22px;
    .m {
      width: 120px;
      padding: 0px 10px;
    }
    .r {
      flex-grow: 1;
      .t {
        height: 44px;
        overflow: hidden;
      }
      .p {
        color: red;
      }
      .o {
        text-align: right;
        color: #999;
        padding-right: 30px;
      }
      .attr {
        height: 22px;
        overflow: hidden;
      }
    }
  }
}
</style>